import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { TranslateModule } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { AccessibilityModule } from 'app/shared/accessibility/accessibility.module';

@Component({
  selector: 'kh-session-expired-modal',
  templateUrl: './session-expired-modal.component.html',
  styleUrls: ['./session-expired-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AccessibilityModule, TranslateModule],
  standalone: true
})
export class SessionExpiredModalComponent implements OnDestroy {
  private readonly bsModalRef = inject(BsModalRef);
  private readonly document = inject(DOCUMENT);
  private readonly loadingBar = inject(LoadingBarService);

  public isSubmitting = false;
  public isStudent = false;
  public ctaHandler: () => Promise<void> = async () => {};

  public constructor() {
    this.document.body.classList.add('blocking-modal-open');
    this.loadingBar.useRef().complete();
    this.loadingBar.useRef('http').complete();
  }

  public ngOnDestroy(): void {
    this.document.body.classList.remove('blocking-modal-open');
  }

  public async onCtaClick(): Promise<void> {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    await this.ctaHandler();
    this.bsModalRef.hide();
  }
}
